<script setup lang="ts">
import moment from 'moment';



const props = defineProps<{
	rtuInfo: any;
}>();



const rtuInfo = computed(() => props.rtuInfo);



</script>

<template>
	<div class="content">
		<div class="wrapper" v-if="rtuInfo">
			<div class="content-wrapper">
				<span class="first_letter">제조사</span>
				<span>{{ commonUtils.isAllStrDataEmpty(rtuInfo.companyName) }}</span>
			</div>

			<div class="content-wrapper">
				<span class="first_letter">모델</span>
				<span>{{ commonUtils.isAllStrDataEmpty(rtuInfo.modelName) }}</span>
			</div>

			<div class="content-wrapper">
				<span class="first_letter">제조연월</span>
				<span>{{ rtuInfo.makeDate ? moment(rtuInfo.makeDate).format('YYYY-MM-DD') : '-' }}</span>
			</div>

			<div class="content-wrapper">
				<span class="first_letter">KC인증번호</span>
				<span>{{ commonUtils.isAllStrDataEmpty(rtuInfo.kcNumber) }}</span>
			</div>

			<div class="content-wrapper">
				<span class="first_letter">IMEI</span>
				<span>{{ commonUtils.isAllStrDataEmpty(rtuInfo.imei) }}</span>
			</div>

			<div class="content-wrapper">
				<span class="first_letter">통신방식(RTU <-> 설비)</span>
				<span>{{ commonUtils.isAllStrDataEmpty(rtuInfo.iftype) }}</span>
			</div>
			<div class="content-wrapper">
				<span class="first_letter">시리얼번호</span>
				<span>{{ commonUtils.isAllStrDataEmpty(rtuInfo.serialNumber) }}</span>
			</div>
		</div>
	<div class="spec-no-data" v-else>RTU정보가 존재하지 않습니다.</div>	
	</div>

</template>

<style lang="scss" scoped>
@import "@/assets/styles/design-toc/in-equip-card.scss"
</style>